const VerticalLayout = () => import('@/layouts/VerticalLayout')

const customers = () => import('./views/index')
const accountsList = () => import('./views/accounts/list')

const accountsDetails = () => import('./views/accounts/details')

const purchasesSection = () => import('./views/sections/purchases')
const giftsSection = () => import('./views/sections/gifts')
const servicesSection = () => import('./views/sections/services')

const purchasesCurrent = () => import('./views/purchases/current.vue')
const purchasesHistory = () => import('./views/purchases/history.vue')
const giftsCurrent = () => import('./views/gifts/current.vue')
const giftsHistory = () => import('./views/gifts/history.vue')

const activity = () => import('./views/activity')

// Tabs of this page, in display order; a tab the account can't open falls back to the next allowed one.
const fallbackRoutes = ['customers.accounts', 'customers.activity.purchases.current', 'customers.activity.purchases.history', 'customers.activity.gifts.current', 'customers.activity.gifts.history', 'customers.activity.services']

export default [
  {
    path: '/business/customers',
    name: 'BusinessCustomers',
    component: VerticalLayout,
    children: [{
      path: '',
      name: 'BusinessCustomers',
      component: customers,
      redirect: { name: 'customers.activity' },
      meta: { name: 'customers', userType: 'provider', serviceTypes: 'all', permission: ['customer_list', 'purchase_purchases', 'purchase_history', 'purchase_gifts', 'purchase_history_gift', 'purchase_collection'] },
      children: [
        {
          path: 'accounts',
          name: 'customers.accounts',
          component: accountsList,
          meta: { name: 'accounts', userType: 'provider', serviceTypes: 'all', permission: 'customer_list', fallbackRoutes }
        },
        {
          path: 'activity',
          name: 'customers.activity',
          component: activity,
          redirect: { name: 'customers.activity.purchases' },
          meta: { name: 'activity', userType: 'provider', serviceTypes: 'all', permission: ['purchase_purchases', 'purchase_history', 'purchase_gifts', 'purchase_history_gift', 'purchase_collection'] },
          children: [
            {
              path: 'purchases',
              name: 'customers.activity.purchases',
              component: purchasesSection,
              redirect: { name: 'customers.activity.purchases.current' },
              meta: { name: 'purchases', userType: 'provider', serviceTypes: 'all', permission: ['purchase_purchases', 'purchase_history'] },
              children: [
                {
                  path: 'current',
                  name: 'customers.activity.purchases.current',
                  component: purchasesCurrent,
                  meta: { name: 'current', userType: 'provider', serviceTypes: 'all', permission: 'purchase_purchases', fallbackRoutes }
                },
                {
                  path: 'history',
                  name: 'customers.activity.purchases.history',
                  component: purchasesHistory,
                  meta: { name: 'history', userType: 'provider', serviceTypes: 'all', permission: 'purchase_history', fallbackRoutes }
                }
              ]
            },
            {
              path: 'gifts',
              name: 'customers.activity.gifts',
              component: giftsSection,
              redirect: { name: 'customers.activity.gifts.current' },
              meta: { name: 'gifts', userType: 'provider', serviceTypes: 'all', permission: ['purchase_gifts', 'purchase_history_gift'] },
              children: [
                {
                  path: 'current',
                  name: 'customers.activity.gifts.current',
                  component: giftsCurrent,
                  meta: { name: 'current', userType: 'provider', serviceTypes: 'all', permission: 'purchase_gifts', fallbackRoutes }
                },
                {
                  path: 'history',
                  name: 'customers.activity.gifts.history',
                  component: giftsHistory,
                  meta: { name: 'history', userType: 'provider', serviceTypes: 'all', permission: 'purchase_history_gift', fallbackRoutes }
                }
              ]
            },
            {
              path: 'services',
              name: 'customers.activity.services',
              component: servicesSection,
              meta: { name: 'services', userType: 'provider', serviceTypes: 'all', permission: 'purchase_collection', fallbackRoutes }
            }
          ]
        }
      ]
    },
    {
      path: 'account',
      name: 'customers.accountsDetails',
      component: accountsDetails,
      redirect: to => ({ name: 'customers.accountsDetails.purchases', params: to.params }),
      meta: { name: 'accountsDetails', userType: 'provider', serviceTypes: 'all', permission: 'customer_list' },
      children: [
        {
          path: 'purchases/:id?',
          name: 'customers.accountsDetails.purchases',
          component: purchasesSection,
          redirect: to => ({ name: 'customers.accountsDetails.purchases.current', params: to.params }),
          meta: { name: 'purchases', userType: 'provider', serviceTypes: 'all', permission: ['purchase_purchases', 'purchase_history'] },
          children: [
            {
              path: 'current',
              name: 'customers.accountsDetails.purchases.current',
              component: purchasesCurrent,
              meta: { name: 'current', userType: 'provider', serviceTypes: 'all', permission: 'purchase_purchases' }
            },
            {
              path: 'history',
              name: 'customers.accountsDetails.purchases.history',
              component: purchasesHistory,
              meta: { name: 'history', userType: 'provider', serviceTypes: 'all', permission: 'purchase_history' }
            }
          ]
        },
        {
          path: 'gifts/:id?',
          name: 'customers.accountsDetails.gifts',
          component: giftsSection,
          redirect: to => ({ name: 'customers.accountsDetails.gifts.current', params: to.params }),
          meta: { name: 'gifts', userType: 'provider', serviceTypes: 'all', permission: ['purchase_gifts', 'purchase_history_gift'] },
          children: [
            {
              path: 'current',
              name: 'customers.accountsDetails.gifts.current',
              component: giftsCurrent,
              meta: { name: 'current', userType: 'provider', serviceTypes: 'all', permission: 'purchase_gifts' }
            },
            {
              path: 'history',
              name: 'customers.accountsDetails.gifts.history',
              component: giftsHistory,
              meta: { name: 'history', userType: 'provider', serviceTypes: 'all', permission: 'purchase_history_gift' }
            }
          ]
        },
        {
          path: 'services/:id?',
          name: 'customers.accountsDetails.services',
          component: servicesSection,
          meta: { name: 'services', userType: 'provider', serviceTypes: 'all', permission: 'purchase_collection' }
        }
      ]
    }]
  }
]
